import { useMemo } from 'react';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import FiscalPeriodsEditor from './FiscalPeriodsEditor';
import { normalizeFiscalPeriodConfig } from 'utils/fiscalPeriods';

/**
 * Config-item form fields for the Fiscal Periods platform setting.
 *
 * Owns the Key text field and wraps {@link FiscalPeriodsEditor}. `formData` is
 * normalized once (memoized) into the editor's `config`; editor changes call
 * `setFormData` with a full config and mark JSON valid via `setJsonValid`.
 */
const FiscalPeriodsFields: React.FC<{
  selectedKey: string;
  setSelectedKey: (v: string) => void;
  formData: unknown;
  setFormData: (v: unknown) => void;
  setJsonValid: (v: boolean) => void;
}> = ({ selectedKey, setSelectedKey, formData, setFormData, setJsonValid }) => {
  // Keep a stable config object across Key-only re-renders so FiscalPeriodsEditor's
  // year-preview useMemo is not invalidated by a fresh normalize() every time.
  const config = useMemo(() => normalizeFiscalPeriodConfig(formData), [formData]);

  return (
    <>
      <Form.Group as={Row} className="mb-3" controlId="fiscalPeriodsKey">
        <Form.Label column sm="2">
          Key
        </Form.Label>
        <Col sm="10">
          <Form.Control type="text" name="key" value={selectedKey} onChange={(e) => setSelectedKey(e.target.value)} />
        </Col>
      </Form.Group>

      <FiscalPeriodsEditor
        config={config}
        onChange={(next) => {
          setFormData(next);
          setJsonValid(true);
        }}
      />
    </>
  );
};

export default FiscalPeriodsFields;
